export const HIGHLIGHT_CLASS_NAME = 'highlight';
export const OVERLAY_CLASS_NAME = 'overlay';